import React, { useEffect, useState } from "react";

const Error = ({ textError, condition }) => {
  const [error, setError] = useState(false);
  useEffect(() => (condition ? setError(true) : setError(false)), [condition]);
  return <>{error && <div className="createEvent__error">{textError}</div>}</>;
};

export { Error };
